<template>
  <div style="display:none" id="export">
    <div>
      <Intro1 exporting></Intro1>
      <A1 exporting></A1>
      <A2 exporting></A2>
      <A3 exporting></A3>
      <A4 exporting></A4>
      <A5 exporting></A5>
      <B1 exporting></B1>
      <E1 exporting></E1>
      <E2 exporting></E2>
      <E3 exporting></E3>
      <E4 exporting></E4>
      <E5 exporting></E5>
      <E6 exporting></E6>
      <E7 exporting></E7>
      <E8 exporting></E8>
    </div>
  </div>
</template>
<script>
  import Editor from '@tinymce/tinymce-vue'

  import Disclaimer from '@/components/user/questionnaire/Intro/disclaimer.vue';
  import Intro from '@/components/user/questionnaire/Intro/introductory.vue';
  import ASummary from '@/components/user/questionnaire/A/summary.vue';
  import AIdera from '@/components/user/questionnaire/A/idera.vue';
  import ALiens from '@/components/user/questionnaire/A/liens.vue';
  import ADRights from '@/components/user/questionnaire/A/detentionRights.vue';
  import AComments from '@/components/user/questionnaire/A/comments.vue';
  import BForm from '@/components/user/questionnaire/B/form.vue';
  import EProtectA from '@/components/user/questionnaire/E/protectionismA.vue';
  import EProtectB from '@/components/user/questionnaire/E/protectionismB.vue';
  import EProtectC from '@/components/user/questionnaire/E/protectionismC.vue';
  import EProtectD from '@/components/user/questionnaire/E/protectionismD.vue';
  import EInterpretation from '@/components/user/questionnaire/E/contractInterpretation.vue';
  import EEnforcement from '@/components/user/questionnaire/E/enforceability.vue';
  import ENoBankrupt from '@/components/user/questionnaire/E/reposessionNonBankruptcy.vue';
  import EBankrupt from '@/components/user/questionnaire/E/reposessionBankruptcy.vue';

  export default {
    components: {
      "Intro1": Disclaimer,
      "Intro2": Intro,
      "A1": ASummary,
      "A2": AIdera,
      "A3": ALiens,
      "A4": ADRights,
      "A5": AComments,
      "B1": BForm,
      "E1": EProtectA,
      "E2": EProtectB,
      "E3": EProtectC,
      "E4": EProtectD,
      "E5": EInterpretation,
      "E6": EEnforcement,
      "E7": ENoBankrupt,
      "E8": EBankrupt
    },
    data() {
      return {
        editor: Editor,
        editorConfig: {
          toolbar: {
            items: ['heading', '|', 'bold', 'italic', 'numberedList']
          }
        },
        adminComment: ''
      }
    },
    props: {
      options: Object
    },
    methods: {
      async saveAdminComment(sectionId) {
        await this.$http.post("api/questionnaire/adminComment/save", { questionnaireId: this.options.Id, sectionId: sectionId, comment: this.adminComment });
      },
      async getAdminComment(sectionId) {
        await this.$http.post("api/questionnaire/adminComment", { questionnaireId: this.options.Id, sectionId: sectionId })
          .then(resp => {
            this.adminComment = resp.data.Comment;
          }).catch(err => {
            this.$buefy.notification.open("Could not load Admin Comment.");
          })
      },
      Export() {
        this.$nextTick(async () => {
          setTimeout(async () => {
            var html = document.getElementById("export").innerHTML;
            var resp = await this.$http({ method: 'post', url: 'api/print', data: { html: html }, responseType: 'arraybuffer' });
            let blob = new Blob([resp.data]);
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', "".concat(this.options.CountryName, " ", this.options.PeriodName, " Questionnaire.pdf"));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$emit("complete");
          },
            100);
        });
      }
    },
    created() {
      var count = 0;
      this.$store.getters.bus.$on("loaded", (e) => {
        if (e && e.exporting) {
          count++;
        }
        if (count == 15) {
          this.Export();
          count = 0;
        }
      });
    },
    mounted() {
      
    },
    beforeDestroy() {
      delete this.$store.getters.bus._events.loaded;
    }
  }
</script>
